module.exports = __webpack_public_path__ + "files/be3061ad2aa1d9e0a68edde03c8c6aec.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/pdf.png
// module id = 405
// module chunks = 60